module.exports = fox._r("images/left-menu-sprite.png", __webpack_public_path__ + "_/_/_/common/frame/images/left-menu-sprite.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/left-menu-sprite.png
// module id = 127
// module chunks = 2